<template>
    <div id="subLeftOne" style=" height: 110%; padding: 30px;"></div>
</template>

<script>
import echarts from 'echarts'
import loopShowTooltip from '../../../../assets/js/cycleHighLight'
export default {
  name: 'SubLeftOne',
  props: ['areaId'],
  data(){
    return {
      // 巡检情况
      AreaInspectSta:{
        "version": 1,
        "method": "synthScreen.DevSta",
        "params": {
          "areaId":"",
        },
        "token": "#",
        "id": 0
      },
      chart:"",

      inspectNum:1,  // 2019已巡检设备数
      nonInspectNum: 1, // 未巡检设备数

      formerInspectNum: -1,  // 上一次已巡检设备数
      formerNonInspectNum: -1, // 上一次未巡检设备数

      interval: null, // 轮询
      option : {
        title: {
          text: '',
              y: '10px',
              x:'10px',
              textStyle:{
                //文字颜色
                color:'white',
                //字体风格,'normal','italic','oblique'
                fontStyle:'normal',
                //字体粗细 'normal','bold','bolder','lighter',100 | 200 | 300 | 400...
                // fontWeight:'bold',
                //字体系列
                fontFamily:'黑体',
                //字体大小
                fontSize:18,
                fontWeight: 'bold',
              }
        },
        tooltip: {
          trigger: 'item',
          formatter: ' <br/>{b} : {c}'
        },
        legend: {
          type: 'scroll',
          orient: 'vertical',
          right: 10,
          top: 20,
          bottom: 20,
          textStyle: {
            color: '#fff',
            fontSize: 15,
            fontFamily: '黑体'
          }

        },
        color: ['#00b3ff', "#f8b067"],
        series: [
          {
            name: '姓名',
            type: 'pie',
            radius: '55%',
            center: ['40%', '60%'],
            data: [
              {value:"", name:""},
              {value:"", name:""},
            ],
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      },
      // option:{
      //   title:{
      //     text: '2019年巡检状况',
      //     y: '10px',
      //     textStyle:{
      //       //文字颜色
      //       color:'white',
      //       //字体风格,'normal','italic','oblique'
      //       fontStyle:'normal',
      //       //字体粗细 'normal','bold','bolder','lighter',100 | 200 | 300 | 400...
      //       // fontWeight:'bold',
      //       //字体系列
      //       fontFamily:'黑体',
      //       //字体大小
      //       fontSize:18,
      //       fontWeight: 'bold',
      //     }
      //   },
      //   grid: {
      //     left: '3%',
      //     right: '4%',
      //     bottom: '3%',
      //     containLabel: true
      //   },
      //   // tooltip: {
      //   //   trigger: 'item',
      //   //   formatter: "{a} <br/>{b}: {c} ({d}%)"
      //   // },
      //   legend: {
      //     // orient: 'vertical',
      //     y: 'bottom',
      //     icon: "circle",
      //     // data:['已巡检','未巡检'],
      //     textStyle: {
      //       color: '#fff',
      //       fontSize: 15,
      //       fontFamily: '黑体'
      //     },
      //     tooltip: {
      //       trigger: 'item',
      //       formatter: '{a} <br/>{b} : {c} ({d}%)'
      //     }
      //     // formatter: function (name) {
      //     //   return name.substr(name.indexOf('\n') + 1);
      //     // }
      //   },
      //   color: ['#00b3ff', "#f8b067"],
      //   series: [
      //     {
      //       name:'巡检',
      //       type:'pie',
      //       radius: '55%',
      //       center: ['40%', '50%'],
      //       avoidLabelOverlap: false,
      //       label: {
      //         normal: {
      //           show: false,
      //           position: 'center'
      //         },
      //         emphasis: {
      //           itemStyle: {
      //             shadowBlur: 10,
      //             shadowOffsetX: 0,
      //             shadowColor: 'rgba(0, 0, 0, 0.5)'
      //           }
      //         //   show: true,
      //         //   textStyle: {
      //         //     fontSize: '26',
      //         //     // fontWeight: 'bold',
      //         //     fontFamily: '新宋体'
      //         //   },
      //         //   label: {
      //         //     show: true,
      //         //     message: "haha"
      //         //     // position: 默认自适应，水平布局为'top'，垂直布局为'right'，可选为
      //         //     //           'inside'|'left'|'right'|'top'|'bottom'
      //         //     // textStyle: null      // 默认使用全局文本样式，详见TEXTSTYLE
      //         //   }
      //         }
      //       },
      //       labelLine: {
      //         normal: {
      //           show: true,
      //           length:20
      //         }
      //       },
      //       data:[
      //         {value:"", name:""},
      //         {value:"", name:""},
      //       ]
      //     }
      //   ]
      // },
    }
  },
  methods: {
    getAreaInspectSta(){
      this.AreaInspectSta.token = this.$store.state.token;
      this.$axios.post(this.$newMainUrl, this.AreaInspectSta).then(res=> {
        if(res.data.hasOwnProperty('result')){
          this.option.title.text = res.data.result.year+"年巡检情况"
          let devNum = res.data.result.operNum[this.areaId]["devNum"];
          this.nonInspectNum = res.data.result.operNum[this.areaId]["nonInspectNum"];
          this.inspectNum = devNum-this.nonInspectNum;
          if(this.inspectNum !== this.formerInspectNum || this.nonInspectNum !== this.formerNonInspectNum){
            this.option.series[0].data[0].value = this.inspectNum;
            this.option.series[0].data[1].value = +this.nonInspectNum;
            if(this.inspectNum + this.nonInspectNum !== 0){
              this.option.series[0].data[0].name = ((this.inspectNum/(this.inspectNum + this.nonInspectNum) * 100) + "").substr(0, 4) + "%" + "\n" + "已巡检";
              this.option.series[0].data[1].name = ((this.nonInspectNum/(this.inspectNum + this.nonInspectNum) * 100) + "").substr(0, 4) + "%" + "\n" + "未巡检";
            }
            else{
              this.option.series[0].data[0].name = "0" + "%" + "\n" + "已巡检";
              this.option.series[0].data[1].name = "0" + "%" + "\n" + "未巡检";
            }
            this.drawChart(this.chart, 'subLeftOne', this.option);
          }

        }else{
          this.$message({
            type:'error',
            message:'获取警报点静态信息失败，' + res.data.error.message
          })
        }
      })
    },
    drawChart(chart, id, option){
        this.formerNonInspectNum = this.nonInspectNum;
        this.formerInspectNum = this.inspectNum;
        // 绘制表格
        console.log('绘制左上子组件');
        chart = echarts.init(document.getElementById(id))
        chart.setOption(option);
        //loopShowTooltip(chart, option, 2);  // 让屏幕动起来

        // // 默认高亮
        // let index = 0; // 高亮索引
        // chart.dispatchAction({
        //   type: "highlight",
        //   seriesIndex: index,
        //   dataIndex: index
        // });
        // chart.on("mouseover", function(e) {
        //   if (e.dataIndex !== index) {
        //     chart.dispatchAction({
        //       type: "downplay",
        //       seriesIndex: 0,
        //       dataIndex: index
        //     });
        //   }
        // });
        // chart.on("mouseout", function(e) {
        //   index = e.dataIndex;
        //   chart.dispatchAction({
        //     type: "highlight",
        //     seriesIndex: 0,
        //     dataIndex: e.dataIndex
        //   });
        // })


    }
  },
  // watch:{
  //   inHeme(newValue, oldValue){
  //     this.drawChart(this.chart, 'subLeftOne', this.option);
  //   }
  // },
  mounted () {
    this.getAreaInspectSta();
    this.interval = setInterval(()=>{
      this.getAreaInspectSta();
    }, 3000);
    // this.drawChart(this.chart, 'subLeftOne', this.option);
  },
  destroyed () {
    clearInterval(this.interval);
    // this.$message({
    //   type:'error',
    //   message:'结束'
    // })
  }
}
</script>

<style scoped>

</style>
